import React, { Fragment } from 'react';
import styles from '../Cards/KPICards.module.css';

const DividerTiles = ({ label, data }) => {
    const divider1Text = label?.split("||")[0];
    const divider2Text = label?.split("||")?.pop();
    const divider1Count = data?.wtd;
    const divider2Count = data?.agileor;
    return (
        <Fragment>
            <div className={styles.paichartContainer}>
                <div className={styles.agileorDiv}>
                    <span className={styles.kpiText}>{divider1Text}*</span>
                    <span className={styles.count}>{divider1Count}</span>
                </div>
                <div className={styles.dividerDiv}></div>
                <div className={styles.agileorDiv}>
                    <span className={styles.kpiText}>{divider2Text}*</span>
                    <span className={styles.count}>{divider2Count}</span>
                </div>
            </div>
            <div style={{height:'5px'}}>
                <span style={{color:'gray', float:'right', cursor:'pointer', fontSize:'10px'}}><strong>*</strong>Underproduction</span>
            </div>
        </Fragment>
    );
};

export default DividerTiles;